import React from 'react';
import PropTypes from 'prop-types';

export const VerifiedCallerIdStats = ({ totalCount, verifiedCount, pendingCount, failedCount }) => {
  return (
    <div className="phone-inventory-stats">
      <div className="stat-item">
        <div className="stat-label">Total</div>
        <div className="stat-value">{totalCount}</div>
      </div>

      <div className="stat-item">
        <div className="stat-label">Verified</div>
        <div className="stat-value">{verifiedCount}</div>
      </div>

      <div className="stat-item">
        <div className="stat-label">Pending</div>
        <div className="stat-value">{pendingCount}</div>
      </div>

      <div className="stat-item">
        <div className="stat-label">Failed</div>
        <div className="stat-value">{failedCount}</div>
      </div>
    </div>
  );
};

VerifiedCallerIdStats.propTypes = {
  totalCount: PropTypes.number.isRequired,
  verifiedCount: PropTypes.number.isRequired,
  pendingCount: PropTypes.number.isRequired,
  failedCount: PropTypes.number.isRequired,
};

VerifiedCallerIdStats.defaultProps = {
  totalCount: 0,
  verifiedCount: 0,
  pendingCount: 0,
  failedCount: 0,
};
